export const countriesConfig = [
    {
        code: 'ht',
        label: 'Haïti',
        administrativeAreaLabel: 'Département',
        hasPostalCode: false,
        departments: [
            {
                name: 'Ouest',
                cities: ['Port-au-Prince', 'Carrefour', 'Delmas', 'Pétion-Ville', 'Cité Soleil', 'Tabarre', 'Croix-des-Bouquets', 'Kenscoff', 'Gressier', 'Léogâne', 'Petit-Goâve', 'Grand-Goâve', 'Cabaret', 'Arcahaie', 'Cornillon', 'Fonds-Verrettes', 'Ganthier', 'Thomazeau', 'Pointe-à-Raquette', 'Anse-à-Galets']
            },
            {
                name: 'Nord',
                cities: ['Cap-Haïtien', 'Acul-du-Nord', 'Limonade', 'Quartier-Morin', 'Plaine-du-Nord', 'Milot', 'Dondon', 'La Victoire', 'Pignon', 'Ranquitte', 'Bahon', 'Grande-Rivière-du-Nord', 'Limbé', 'Bas-Limbé', 'Borgne', 'Port-Margot', 'Pilate', 'Plaisance', 'Saint-Raphaël']
            },
            {
                name: 'Sud',
                cities: ['Les Cayes', 'Camp-Perrin', 'Chantal', 'Maniche', 'Île-à-Vache', 'Torbeck', 'Aquin', 'Cavaillon', 'Saint-Louis-du-Sud', 'Les Anglais', 'Chardonnières', 'Roche-à-Bateau', 'Côteaux', 'Port-à-Piment', 'Dammarie']
            },
            {
                name: 'Artibonite',
                cities: ['Gonaïves', 'Ennery', 'L\'Estère', 'Dessalines', 'Petite-Rivière-de-l\'Artibonite', 'Grande-Saline', 'Desdunes', 'Gros-Morne', 'Anse-Rouge', 'Terre-Neuve', 'Saint-Michel-de-l\'Attalaye', 'Marmelade', 'Saint-Marc', 'Verrettes', 'La Chapelle']
            },
            {
                name: 'Centre',
                cities: ['Hinche', 'Cerca-Carvajal', 'Maïssade', 'Thomassique', 'Mirebalais', 'Saut-d\'Eau', 'Boucan-Carré', 'Lascahobas', 'Belladère', 'Savanette']
            },
            {
                name: 'Grand\'Anse',
                cities: ['Jérémie', 'Abricots', 'Trou-Bonbon', 'Moron', 'Chambellan', 'Marfranc', 'Roseaux', 'Beaumont', 'Pestel', 'Corail', 'Les Irois', 'Anse-d\'Hainault', 'Dame-Marie']
            },
            {
                name: 'Nord-Ouest',
                cities: ['Port-de-Paix', 'Bassin-Bleu', 'Chansolme', 'Île de la Tortue', 'Saint-Louis-du-Nord', 'Anse-à-Foleur', 'Môle-Saint-Nicolas', 'Baie-de-Henne', 'Bombardopolis', 'Jean-Rabel']
            },
            {
                name: 'Nord-Est',
                cities: ['Fort-Liberté', 'Perches', 'Ferrier', 'Ouanaminthe', 'Capotille', 'Mont-Organisé', 'Trou-du-Nord', 'Caracol', 'Sainte-Suzanne', 'Terrier-Rouge', 'Vallières', 'Carice', 'Mombin-Crocro']
            },
            {
                name: 'Sud-Est',
                cities: ['Jacmel', 'Marigot', 'Cayes-Jacmel', 'La Vallée-de-Jacmel', 'Bainet', 'Côtes-de-Fer', 'Belle-Anse', 'Grand-Gosier', 'Thiote', 'Anse-à-Pitres']
            },
            {
                name: 'Nippes',
                cities: ['Miragoâne', 'Petite-Rivière-de-Nippes', 'Fonds-des-Nègres', 'Paillant', 'Anse-à-Veau', 'L\'Asile', 'Petit-Trou-de-Nippes', 'Plaisance-du-Sud', 'Arnaud', 'Baradères', 'Grand-Boucan']
            }
        ]
    },
    {
        code: 'do',
        label: 'République dominicaine',
        administrativeAreaLabel: 'Province',
        hasPostalCode: true
    },
    {
        code: 'us',
        label: 'États-Unis',
        administrativeAreaLabel: 'État',
        hasPostalCode: true
    },
    {
        code: 'ca',
        label: 'Canada',
        administrativeAreaLabel: 'Province / Territoire',
        hasPostalCode: true
    },
    {
        code: 'fr',
        label: 'France',
        administrativeAreaLabel: 'Région',
        hasPostalCode: true
    }
];

export const getCountryConfig = (code) => {
    return countriesConfig.find(c => c.code === code) || countriesConfig[0];
};
